import { ApiVaultKeyFormProvider } from "./ApiVaultKeyFormProvider";
import { KeyInputField } from "./components/KeyInputField";
import { SelectKeyType } from "./components/SelectKeyType";

export interface ApiVaultKeyFormProps {}

export const ApiVaultKeyForm = ({}: ApiVaultKeyFormProps) => {
  return null;
};

ApiVaultKeyForm.Provider = ApiVaultKeyFormProvider;
ApiVaultKeyForm.KeyInputField = KeyInputField;
ApiVaultKeyForm.SelectKeyType = SelectKeyType;
